module.exports = __webpack_public_path__ + "img/gallery-img-1.769b0122.jpg";